// source: workspace_default_settings_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var primitive_proto_pb = require('./primitive_proto_pb.js');
goog.object.extend(proto, primitive_proto_pb);
var command_public_proto_pb = require('./command_public_proto_pb.js');
goog.object.extend(proto, command_public_proto_pb);
goog.exportSymbol('proto.WorkspaceDefaultSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.WorkspaceDefaultSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.WorkspaceDefaultSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.WorkspaceDefaultSettings.displayName = 'proto.WorkspaceDefaultSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.WorkspaceDefaultSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.WorkspaceDefaultSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.WorkspaceDefaultSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.WorkspaceDefaultSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
trackingOn: jspb.Message.getFieldWithDefault(msg, 1, 0),
trackingInterval: jspb.Message.getFieldWithDefault(msg, 2, 0),
gpsInterval: jspb.Message.getFieldWithDefault(msg, 3, 0),
sentTimestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
enableAltitudeReporting: jspb.Message.getFieldWithDefault(msg, 6, 0),
enableSpeedAndCourseReporting: jspb.Message.getFieldWithDefault(msg, 7, 0),
enableBackhaul: jspb.Message.getFieldWithDefault(msg, 8, 0),
iridiumNoSleep: jspb.Message.getFieldWithDefault(msg, 9, 0),
radioMode: jspb.Message.getFieldWithDefault(msg, 10, 0),
lowSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 11, 0),
highSpeedFrequencyHz: jspb.Message.getFieldWithDefault(msg, 12, 0),
radioPowerMode: jspb.Message.getFieldWithDefault(msg, 13, 0),
buttonFunction: jspb.Message.getFieldWithDefault(msg, 14, 0),
meshVersionToDeploy: jspb.Message.getFieldWithDefault(msg, 15, 0),
lowSpeedDataRateParameters: (f = msg.getLowSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f),
highSpeedDataRateParameters: (f = msg.getHighSpeedDataRateParameters()) && command_public_proto_pb.RadioDataRateParameters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.WorkspaceDefaultSettings}
 */
proto.WorkspaceDefaultSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.WorkspaceDefaultSettings;
  return proto.WorkspaceDefaultSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.WorkspaceDefaultSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.WorkspaceDefaultSettings}
 */
proto.WorkspaceDefaultSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setTrackingOn(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrackingInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setGpsInterval(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setSentTimestamp(value);
      break;
    case 6:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEnableAltitudeReporting(value);
      break;
    case 7:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEnableSpeedAndCourseReporting(value);
      break;
    case 8:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setEnableBackhaul(value);
      break;
    case 9:
      var value = /** @type {!proto.OptionalBool} */ (reader.readEnum());
      msg.setIridiumNoSleep(value);
      break;
    case 10:
      var value = /** @type {!proto.RadioMode} */ (reader.readEnum());
      msg.setRadioMode(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLowSpeedFrequencyHz(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHighSpeedFrequencyHz(value);
      break;
    case 13:
      var value = /** @type {!proto.RadioPowerMode} */ (reader.readEnum());
      msg.setRadioPowerMode(value);
      break;
    case 14:
      var value = /** @type {!proto.ButtonFunction} */ (reader.readEnum());
      msg.setButtonFunction(value);
      break;
    case 15:
      var value = /** @type {!proto.MeshVersion} */ (reader.readEnum());
      msg.setMeshVersionToDeploy(value);
      break;
    case 16:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setLowSpeedDataRateParameters(value);
      break;
    case 17:
      var value = new command_public_proto_pb.RadioDataRateParameters;
      reader.readMessage(value,command_public_proto_pb.RadioDataRateParameters.deserializeBinaryFromReader);
      msg.setHighSpeedDataRateParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.WorkspaceDefaultSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.WorkspaceDefaultSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.WorkspaceDefaultSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.WorkspaceDefaultSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrackingOn();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTrackingInterval();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getGpsInterval();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSentTimestamp();
  if (f !== 0) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getEnableAltitudeReporting();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getEnableSpeedAndCourseReporting();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getEnableBackhaul();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getIridiumNoSleep();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getRadioMode();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getLowSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getHighSpeedFrequencyHz();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getRadioPowerMode();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getButtonFunction();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getMeshVersionToDeploy();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getLowSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
  f = message.getHighSpeedDataRateParameters();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      command_public_proto_pb.RadioDataRateParameters.serializeBinaryToWriter
    );
  }
};


/**
 * optional OptionalBool tracking_on = 1;
 * @return {!proto.OptionalBool}
 */
proto.WorkspaceDefaultSettings.prototype.getTrackingOn = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setTrackingOn = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 tracking_interval = 2;
 * @return {number}
 */
proto.WorkspaceDefaultSettings.prototype.getTrackingInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setTrackingInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 gps_interval = 3;
 * @return {number}
 */
proto.WorkspaceDefaultSettings.prototype.getGpsInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setGpsInterval = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional fixed32 sent_timestamp = 5;
 * @return {number}
 */
proto.WorkspaceDefaultSettings.prototype.getSentTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setSentTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional OptionalBool enable_altitude_reporting = 6;
 * @return {!proto.OptionalBool}
 */
proto.WorkspaceDefaultSettings.prototype.getEnableAltitudeReporting = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setEnableAltitudeReporting = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional OptionalBool enable_speed_and_course_reporting = 7;
 * @return {!proto.OptionalBool}
 */
proto.WorkspaceDefaultSettings.prototype.getEnableSpeedAndCourseReporting = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setEnableSpeedAndCourseReporting = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional OptionalBool enable_backhaul = 8;
 * @return {!proto.OptionalBool}
 */
proto.WorkspaceDefaultSettings.prototype.getEnableBackhaul = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setEnableBackhaul = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional OptionalBool iridium_no_sleep = 9;
 * @return {!proto.OptionalBool}
 */
proto.WorkspaceDefaultSettings.prototype.getIridiumNoSleep = function() {
  return /** @type {!proto.OptionalBool} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.OptionalBool} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setIridiumNoSleep = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional RadioMode radio_mode = 10;
 * @return {!proto.RadioMode}
 */
proto.WorkspaceDefaultSettings.prototype.getRadioMode = function() {
  return /** @type {!proto.RadioMode} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.RadioMode} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setRadioMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional uint32 low_speed_frequency_hz = 11;
 * @return {number}
 */
proto.WorkspaceDefaultSettings.prototype.getLowSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setLowSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional uint32 high_speed_frequency_hz = 12;
 * @return {number}
 */
proto.WorkspaceDefaultSettings.prototype.getHighSpeedFrequencyHz = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setHighSpeedFrequencyHz = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional RadioPowerMode radio_power_mode = 13;
 * @return {!proto.RadioPowerMode}
 */
proto.WorkspaceDefaultSettings.prototype.getRadioPowerMode = function() {
  return /** @type {!proto.RadioPowerMode} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.RadioPowerMode} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setRadioPowerMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional ButtonFunction button_function = 14;
 * @return {!proto.ButtonFunction}
 */
proto.WorkspaceDefaultSettings.prototype.getButtonFunction = function() {
  return /** @type {!proto.ButtonFunction} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.ButtonFunction} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setButtonFunction = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional MeshVersion mesh_version_to_deploy = 15;
 * @return {!proto.MeshVersion}
 */
proto.WorkspaceDefaultSettings.prototype.getMeshVersionToDeploy = function() {
  return /** @type {!proto.MeshVersion} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.MeshVersion} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.setMeshVersionToDeploy = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional RadioDataRateParameters low_speed_data_rate_parameters = 16;
 * @return {?proto.RadioDataRateParameters}
 */
proto.WorkspaceDefaultSettings.prototype.getLowSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 16));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
*/
proto.WorkspaceDefaultSettings.prototype.setLowSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.clearLowSpeedDataRateParameters = function() {
  return this.setLowSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WorkspaceDefaultSettings.prototype.hasLowSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional RadioDataRateParameters high_speed_data_rate_parameters = 17;
 * @return {?proto.RadioDataRateParameters}
 */
proto.WorkspaceDefaultSettings.prototype.getHighSpeedDataRateParameters = function() {
  return /** @type{?proto.RadioDataRateParameters} */ (
    jspb.Message.getWrapperField(this, command_public_proto_pb.RadioDataRateParameters, 17));
};


/**
 * @param {?proto.RadioDataRateParameters|undefined} value
 * @return {!proto.WorkspaceDefaultSettings} returns this
*/
proto.WorkspaceDefaultSettings.prototype.setHighSpeedDataRateParameters = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.WorkspaceDefaultSettings} returns this
 */
proto.WorkspaceDefaultSettings.prototype.clearHighSpeedDataRateParameters = function() {
  return this.setHighSpeedDataRateParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.WorkspaceDefaultSettings.prototype.hasHighSpeedDataRateParameters = function() {
  return jspb.Message.getField(this, 17) != null;
};


goog.object.extend(exports, proto);
